import React from 'react';
import View from './View';
import adaptData from './adaptData';

const Header = ({ data }) => {
   return <View {...adaptData(data)} />;
};

export default Header;
